import { CustomerMethodologyPage } from "../../components/CustomerMethodologyPage";

export function RegulatoryHorizonMethodology() {
  return (
    <CustomerMethodologyPage
      title="Regulatory horizon — overview"
      description="How WeConsult Rx maintains its regulatory catalog, what it covers, and what it deliberately does not do."
      path="/trust/regulatory-horizon-methodology"
    >
      <p>
        The regulatory horizon dashboard is a <strong>curated catalog</strong> of
        regulatory changes that bear on long-term-care pharmacy and consultant
        practice. Entries are filtered to your tenant&apos;s declared operating
        jurisdictions and facility types.
      </p>

      <h2>How it is maintained</h2>
      <p>
        Entries are written and revised by hand, and reviewed quarterly. This is
        not an automated feed: nothing scrapes the Federal Register or state
        board sites, and no entry appears without a person deciding it belongs
        there. Each entry shows when it was last updated, so you can judge for
        yourself how current it is.
      </p>

      <h2>What it covers</h2>
      <ul>
        <li>
          22 entries across federal, state and international regimes — HIPAA,
          CMS, DEA, DSCSA, SAMHSA 42 CFR Part 2, Section 1557, state boards of
          pharmacy, state consumer-privacy law and the EU AI Act.
        </li>
        <li>
          Where an entry cites a specific authority — an F-tag, or a CFR section
          — the platform resolves it to the rule-pack rules and readiness
          templates that cite the same authority, and shows which ones. An entry
          citing only a Federal Register page, or a CFR part as a whole, cannot
          be resolved that way and says so rather than implying nothing is
          affected.
        </li>
        <li>
          Federal coverage is the substantive part. State coverage is
          <strong> limited and added on request</strong> — do not assume your
          state is represented.
        </li>
        <li>
          Filtering by your operating jurisdictions and facility types, so you
          see the entries that apply to you.
        </li>
        <li>
          Both rules already in force and those still pending. Most entries in
          the catalog today are already effective.
        </li>
      </ul>

      <h2>What it is not</h2>
      <p>
        It is not a monitoring service and does not replace one. It gives no
        guarantee that a given rule change will appear, or appear before its
        effective date. If regulatory monitoring is a control you must be able
        to evidence, treat this as a supplement to that control and not as the
        control itself.
      </p>
      <p>
        It is educational reference material, not legal advice. Every entry
        links to the official source — the Federal Register notice, agency
        guidance page or board publication it derives from — so you can read the
        primary material rather than our summary of it.
      </p>
    </CustomerMethodologyPage>
  );
}
